<template>
  <div class="result-view">
    <ContentLayout>
      <div class="result-view__content">
        <div class="result-view__message">
          <ProgramTitle
            :prefix="resultViewSettings.prefix"
            :suffix="resultViewSettings.suffix"
            :link="link"
            :title="name"
          />
        </div>
        <div class="result-view__actions">
          <SimpleButton
            :title="resultViewSettings.register_label"
            :to="Routes.register.path"
            light
          />
          <div class="result-view__other-actions">
            <TextButton
              :to="Routes.quiz.path"
              :title="resultViewSettings.repeat_label"
            />
          </div>
          <div class="result-view__social">
            <IconButton
              :link="resultViewSettings.facebook.link"
              :label="resultViewSettings.facebook.label"
            />
          </div>
        </div>
      </div>
    </ContentLayout>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { loadProgramData } from "@/utils";
import store from "@/store";
import { Routes } from "@/constants";

import ProgramTitle from "@/components/ProgramTitle";
import SimpleButton from "@/components/SimpleButton";
import TextButton from "@/components/TextButton";
import IconButton from "@/components/IconButton";
import ContentLayout from "@/layouts/ContentLayout";

export default {
  name: "ResultView",
  components: {
    ProgramTitle,
    SimpleButton,
    TextButton,
    IconButton,
    ContentLayout
  },
  data() {
    return {
      name: "",
      link: "",
      Routes: Routes
    };
  },
  methods: {
    loadResults: function() {
      const resultProgram = store.state.resultProgram;
      if (loadProgramData(resultProgram) && resultProgram) {
        this.name = loadProgramData(resultProgram).genitive;
        this.link = loadProgramData(resultProgram).link;
      } else {
        this.$router.push(Routes.loading.path);
      }
    }
  },
  computed: {
    ...mapState({
      resultViewSettings: state => state.resultViewSettings
    })
  },
  mounted() {
    this.loadResults();
  }
};
</script>

<style lang="scss" scoped>
.result-view {
  $_animation-enter-speed: 1.6s;
  height: 100%;
  padding: 0 spacer("l");

  @include if-tablet {
    align-items: center;
    display: flex;
  }

  &__content {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    justify-content: space-around;
    min-height: 100%;
  }

  &__message {
    animation: enterMessage $_animation-enter-speed ease forwards;
    margin-bottom: spacer("l");
    transform: translateY(-40%);

    @keyframes enterMessage {
      0% {
        opacity: 0;
        transform: translateY(-40%);
      }
      100% {
        opacity: 1;
        transform: translateY(0);
      }
    }
  }

  &__actions {
    align-items: center;
    animation: enterActions $_animation-enter-speed ease forwards;
    display: flex;
    flex-direction: column;
    transform: translateY(40%);

    & > * {
      margin-bottom: spacer("l");
    }

    @keyframes enterActions {
      0% {
        opacity: 0;
        transform: translateY(40%);
      }
      100% {
        opacity: 1;
        transform: translateY(0);
      }
    }
  }

  &__other-actions {
    align-items: center;
    display: flex;
    flex-direction: column;
  }
}
</style>
